"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.networks = exports.zeroAddress = void 0;
exports.zeroAddress = "0x0000000000000000000000000000000000000000";
exports.networks = {
    eth: {
        id: 1,
        name: "Ethereum",
        shortname: "eth",
        native: {
            address: exports.zeroAddress,
            symbol: "ETH",
            decimals: 18,
            logoUrl: "https://app.1inch.io/assets/images/network-logos/ethereum.svg",
        },
        wToken: {
            symbol: "WETH",
            address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
            decimals: 18,
            logoUrl: "https://tokens-data.1inch.io/images/0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2.png",
        },
        publicRpcUrl: "https://eth.llamarpc.com",
        logoUrl: "https://app.1inch.io/assets/images/network-logos/ethereum.svg",
        explorer: "https://etherscan.io",
        eip1559: true,
    },
    bsc: {
        id: 56,
        name: "BinanceSmartChain",
        shortname: "bsc",
        native: {
            address: exports.zeroAddress,
            symbol: "BNB",
            decimals: 18,
            logoUrl: "https://app.1inch.io/assets/images/network-logos/bsc_2.svg",
        },
        wToken: {
            symbol: "WBNB",
            address: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
            decimals: 18,
            logoUrl: "https://tokens-data.1inch.io/images/0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c.png",
        },
        publicRpcUrl: "https://bsc-dataseed.binance.org",
        logoUrl: "https://app.1inch.io/assets/images/network-logos/bsc_2.svg",
        explorer: "https://bscscan.com",
        eip1559: false,
    },
    poly: {
        id: 137,
        name: "Polygon",
        shortname: "poly",
        native: {
            address: exports.zeroAddress,
            symbol: "MATIC",
            decimals: 18,
            logoUrl: "https://app.1inch.io/assets/images/network-logos/polygon.svg",
        },
        wToken: {
            symbol: "WMATIC",
            address: "0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270",
            decimals: 18,
            logoUrl: "https://tokens-data.1inch.io/images/0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270.png",
        },
        publicRpcUrl: "https://polygon-rpc.com",
        logoUrl: "https://app.1inch.io/assets/images/network-logos/polygon.svg",
        explorer: "https://polygonscan.com",
        eip1559: true,
    },
    arb: {
        id: 42161,
        name: "Arbitrum",
        shortname: "arb",
        native: {
            address: exports.zeroAddress,
            symbol: "ETH",
            decimals: 18,
            logoUrl: "https://app.1inch.io/assets/images/network-logos/ethereum.svg",
        },
        wToken: {
            symbol: "WETH",
            address: "0x82af49447d8a07e3bd95bd0d56f35241523fbab1",
            decimals: 18,
            logoUrl: "https://tokens-data.1inch.io/images/0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2.png",
        },
        publicRpcUrl: "https://arb1.arbitrum.io/rpc",
        logoUrl: "https://app.1inch.io/assets/images/network-logos/arbitrum.svg",
        explorer: "https://arbiscan.io",
        eip1559: true,
    },
    sei: {
        id: 1329,
        name: "Sei",
        shortname: "sei",
        native: {
            address: exports.zeroAddress,
            symbol: "SEI",
            decimals: 18,
            logoUrl: "https://assets.coingecko.com/coins/images/28205/standard/Sei_Logo_-_Transparent.png",
        },
        wToken: {
            symbol: "WSEI",
            address: "0xE30feDd158A2e3b13e9badaeABaFc5516e95e8C7",
            decimals: 18,
            logoUrl: "https://tokens-data.1inch.io/images/0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2.png",
        },
        publicRpcUrl: "https://evm-rpc.sei-apis.com",
        logoUrl: "https://assets.coingecko.com/coins/images/28205/standard/Sei_Logo_-_Transparent.png",
        explorer: "https://seitrace.com",
        eip1559: false,
    },
    avax: {
        id: 43114,
        name: "Avalanche",
        shortname: "avax",
        native: {
            address: exports.zeroAddress,
            symbol: "AVAX",
            decimals: 18,
            logoUrl: "https://app.1inch.io/assets/images/network-logos/avalanche.svg",
        },
        wToken: {
            symbol: "WAVAX",
            address: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7",
            decimals: 18,
            logoUrl: "https://tokens-data.1inch.io/images/0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7.png",
        },
        publicRpcUrl: "https://api.avax.network/ext/bc/C/rpc",
        logoUrl: "https://app.1inch.io/assets/images/network-logos/avalanche.svg",
        explorer: "https://snowtrace.io",
        eip1559: true,
    },
    ftm: {
        id: 250,
        name: "Fantom",
        shortname: "ftm",
        native: {
            address: exports.zeroAddress,
            symbol: "FTM",
            decimals: 18,
            logoUrl: "https://app.1inch.io/assets/images/network-logos/fantom.svg",
        },
        wToken: {
            symbol: "WFTM",
            address: "0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83",
            decimals: 18,
            logoUrl: "https://tokens-data.1inch.io/images/0x4e15361fd6b4bb609fa63c81a2be19d873717870.png",
        },
        publicRpcUrl: "https://rpc.ftm.tools",
        logoUrl: "https://app.1inch.io/assets/images/network-logos/fantom.svg",
        explorer: "https://ftmscan.com",
        eip1559: true,
    },
    base: {
        id: 8453,
        name: "Base",
        shortname: "base",
        native: {
            address: exports.zeroAddress,
            symbol: "ETH",
            decimals: 18,
            logoUrl: "https://app.1inch.io/assets/images/network-logos/ethereum.svg",
        },
        wToken: {
            symbol: "WETH",
            address: "0x4200000000000000000000000000000000000006",
            decimals: 18,
            logoUrl: "https://tokens-data.1inch.io/images/0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2.png",
        },
        publicRpcUrl: "https://mainnet.base.org",
        logoUrl: "https://app.1inch.io/assets/images/network-logos/base.svg",
        explorer: "https://basescan.org",
        eip1559: false,
    },
    linea: {
        id: 59144,
        name: "Linea",
        shortname: "linea",
        native: {
            address: exports.zeroAddress,
            symbol: "ETH",
            decimals: 18,
            logoUrl: "https://app.1inch.io/assets/images/network-logos/ethereum.svg",
        },
        wToken: {
            symbol: "WETH",
            address: "0xe5D7C2a44FfDDf6b295A15c148167daaAf5Cf34f",
            decimals: 18,
            logoUrl: "https://tokens-data.1inch.io/images/0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2.png",
        },
        publicRpcUrl: "https://rpc.linea.build",
        logoUrl: "https://lineascan.build/images/logo.svg",
        explorer: "https://lineascan.build",
        eip1559: false,
    },
    zksync: {
        id: 324,
        name: "zksync",
        shortname: "zksync",
        native: {
            address: exports.zeroAddress,
            symbol: "ETH",
            decimals: 18,
            logoUrl: "https://app.1inch.io/assets/images/network-logos/ethereum.svg",
        },
        wToken: {
            symbol: "WETH",
            address: "0x5AEa5775959fBC2557Cc8789bC1bf90A239D9a91",
            decimals: 18,
            logoUrl: "https://tokens-data.1inch.io/images/0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2.png",
        },
        publicRpcUrl: "https://mainnet.era.zksync.io",
        logoUrl: "https://raw.githubusercontent.com/matter-labs/zksync/0a4ca2145a0c95b5bafa84c2f095c644907a8825/zkSyncLogo.svg",
        explorer: "https://explorer.zksync.io/",
        eip1559: true,
    },
    zkevm: {
        id: 1101,
        name: "zkevm",
        shortname: "zkevm",
        native: {
            address: exports.zeroAddress,
            symbol: "ETH",
            decimals: 18,
            logoUrl: "https://app.1inch.io/assets/images/network-logos/ethereum.svg",
        },
        wToken: {
            symbol: "WETH",
            address: "0x4F9A0e7FD2Bf6067db6994CF12E4495Df938E6e9",
            decimals: 18,
            logoUrl: "https://tokens-data.1inch.io/images/0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2.png",
        },
        publicRpcUrl: "https://zkevm-rpc.com",
        logoUrl: "https://user-images.githubusercontent.com/18598517/235932702-bc47eae5-d672-4dd9-9da2-8ea8f51a93f3.png",
        explorer: "https://zkevm.polygonscan.com/",
        eip1559: true,
    },
    manta: {
        id: 169,
        name: "manta",
        shortname: "manta",
        native: {
            address: exports.zeroAddress,
            symbol: "ETH",
            decimals: 18,
            logoUrl: "https://icons.llamao.fi/icons/chains/rsz_manta.jpg",
        },
        wToken: {
            symbol: "WETH",
            address: "0x0Dc808adcE2099A9F62AA87D9670745AbA741746",
            decimals: 18,
            logoUrl: "https://tokens-data.1inch.io/images/0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2.png",
        },
        publicRpcUrl: "https://pacific-rpc.manta.network/http",
        logoUrl: "https://icons.llamao.fi/icons/chains/rsz_manta.jpg",
        explorer: "https://manta.socialscan.io/",
        eip1559: true,
    },
    blast: {
        id: 81457,
        name: "blast",
        shortname: "blast",
        native: {
            address: exports.zeroAddress,
            symbol: "ETH",
            decimals: 18,
            logoUrl: "https://icons.llamao.fi/icons/chains/rsz_blast",
        },
        wToken: {
            symbol: "WETH",
            address: "0x4300000000000000000000000000000000000004",
            decimals: 18,
            logoUrl: "https://tokens-data.1inch.io/images/0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2.png",
        },
        publicRpcUrl: "https://rpc.ankr.com/blast",
        logoUrl: "https://icons.llamao.fi/icons/chains/rsz_blast",
        explorer: "https://blastscan.io/",
        eip1559: true,
    },
    sonic: {
        id: 146,
        name: "sonic",
        shortname: "sonic",
        native: {
            address: exports.zeroAddress,
            symbol: "S",
            decimals: 18,
            logoUrl: "https://icons.llamao.fi/icons/chains/rsz_sonic",
        },
        wToken: {
            symbol: "WS",
            address: "0x039e2fB66102314Ce7b64Ce5Ce3E5183bc94aD38",
            decimals: 18,
            logoUrl: "https://icons.llamao.fi/icons/chains/rsz_sonic",
        },
        publicRpcUrl: "https://rpc.soniclabs.com",
        logoUrl: "https://icons.llamao.fi/icons/chains/rsz_sonic",
        explorer: "https://www.sonicscan.org/",
        eip1559: true,
    },
    scroll: {
        id: 534352,
        name: "scroll",
        shortname: "scroll",
        native: {
            address: exports.zeroAddress,
            symbol: "ETH",
            decimals: 18,
            logoUrl: "https://icons.llamao.fi/icons/chains/rsz_scroll",
        },
        wToken: {
            symbol: "WETH",
            address: "0x5300000000000000000000000000000000000004",
            decimals: 18,
            logoUrl: "https://tokens-data.1inch.io/images/0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2.png",
        },
        publicRpcUrl: "https://scroll-rpc.publicnode.com",
        logoUrl: "https://icons.llamao.fi/icons/chains/rsz_scroll",
        explorer: "https://scrollscan.com/",
        eip1559: true,
    },
    zircuit: {
        id: 48900,
        name: "Zircuit",
        shortname: "zircuit",
        native: {
            address: exports.zeroAddress,
            symbol: "ETH",
            decimals: 18,
            logoUrl: "https://app.1inch.io/assets/images/network-logos/ethereum.svg",
        },
        wToken: {
            symbol: "WETH",
            address: "0x4200000000000000000000000000000000000006",
            decimals: 18,
            logoUrl: "hhttps://tokens-data.1inch.io/images/0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2.png",
        },
        publicRpcUrl: "https://zircuit-mainnet.drpc.org",
        logoUrl: "https://app.1inch.io/assets/images/network-logos/ethereum.svg",
        explorer: "https://explorer.zircuit.com/",
        eip1559: true,
    },
    flare: {
        id: 14,
        name: "flare",
        shortname: "flare",
        native: {
            address: exports.zeroAddress,
            symbol: "FLR",
            decimals: 18,
            logoUrl: "https://icons.llamao.fi/icons/chains/rsz_flare?w=48&h=48",
        },
        wToken: {
            symbol: "WFLR",
            address: "0x1D80c49BbBCd1C0911346656B529DF9E5c2F783d",
            decimals: 18,
            logoUrl: "https://res.cloudinary.com/sparkdex/image/upload/q_100/v1/website-assets/coins/wflr?_a=DATAg1AAZAA0",
        },
        publicRpcUrl: "https://flare.network",
        logoUrl: "https://icons.llamao.fi/icons/chains/rsz_flare?w=48&h=48",
        explorer: "https://flarescan.com",
        eip1559: true,
    },
};
